import {
  falconSiteSettingsSchema,
  offerNetworkDataSharingConsentSchema,
  offerPlacementSelectionSchema,
} from "@redotech/redo-integrations-definitions-common/offer-network/offer-placement";
import * as z from "zod";

export const getOfferNetworkIntegrations = {
  name: "getOfferNetworkIntegrations" as const,
  input: z.null(),
  output: z.object({
    rokt: z.object({
      connected: z.boolean(),
      accountId: z.string().optional(),
    }),
    falcon: z.object({
      connected: z.boolean(),
      publisherId: z.string().optional(),
      siteSettings: falconSiteSettingsSchema.optional(),
    }),
    // True when any provider is connected (provider-agnostic convenience flag).
    anyProviderConnected: z.boolean(),
    // Current Shopify thank-you page placement selection, or null when unset.
    thankYou: offerPlacementSelectionSchema.nullable(),
    // Data-sharing acknowledgment, or null if the merchant hasn't acknowledged.
    dataSharingConsent: offerNetworkDataSharingConsentSchema.nullable(),
  }),
};
